'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Song = void 0;
var $ = require("jquery");
var Song = /** @class */ (function () {
    function Song() {
        $('.trigToTheFuture').on('click', function () {
            $('.bulletSong').attr('data-move', '1');
            $('.bulletBgBeYourSelf').attr('data-show', 'false');
            $('.bulletBgToTheFuture').attr('data-show', 'true');
        });
        $('.trigBeYourself').on('click', function () {
            $('.bulletSong').attr('data-move', '0');
            $('.bulletBgBeYourSelf').attr('data-show', 'true');
            $('.bulletBgToTheFuture').attr('data-show', 'false');
        });
    }
    return Song;
}());
exports.Song = Song;
exports.default = Song;
